export default __webpack_public_path__ + "static/media/italic.2fb43b4e.svg";